/**
 * The live board's 2D/3D preference.
 *
 * Same idiom as `WaiterStation`'s `TAB_KEY` and `Kitchen`'s `STATION_KEY`:
 * `localStorage`, namespaced `venue.<screen>.<thing>`, read and written through
 * a try/catch pair so private browsing (which throws on access) degrades to
 * "forgets the preference" rather than "the screen will not render". Not the
 * URL — `routedTabs.tsx` gives a *mode* a URL because a mode is a place worth
 * linking to (`/floor-map/edit`), but 2D-vs-3D is a rendering preference for
 * one person on one device, the same shape as which paper size the till
 * remembers, not a different screen.
 */
const VIEW_KEY = 'venue.floorMap.view';

export type FloorMapView = '2d' | '3d';

export function storedFloorMapView(): FloorMapView | null {
  try {
    const value = localStorage.getItem(VIEW_KEY);
    return value === '2d' || value === '3d' ? value : null;
  } catch {
    return null;
  }
}

export function storeFloorMapView(view: FloorMapView): void {
  try {
    localStorage.setItem(VIEW_KEY, view);
  } catch {
    // The screen still works; it just will not remember next time.
  }
}
